import { FC, useEffect } from "react";

import { SATOSContentRender } from "@/components/Application/SATOSContentRender";
import { Step } from "@/components/Procedures/Checklist/Step/Step";
import { isHeader } from "@/components/Procedures/Checklist/utils/Helpers";
import { IChecklistStep } from "@/components/Procedures/Checklist/utils/Types";

type ChecklistRowProps = IChecklistStep & {
	scrollContainerId?: string;
};

export const ChecklistRow: FC<ChecklistRowProps> = (props) => {
	useEffect(() => {}, [props.activeSchemeId]);

	if (isHeader(props.step)) {
		return (
			<div
				className="grid-row grid-row-header"
				style={{ background: props.step.BackgroundColor }}
			>
				<div className="grid-column grid-column--header">
					<Header activeSchemeId={props.activeSchemeId} step={props.step} />
				</div>
				<div className="grid-column grid-column-blank" />
			</div>
		);
	}

	return (
		<Step
			activeSchemeId={props.activeSchemeId || 0}
			materialHandling={props.materialHandling}
			step={props.step}
			showCommentsAndSuggestion={props.showCommentsAndSuggestion}
			highlightedStepId={props.highlightedStepId}
			scrollContainerId={props.scrollContainerId}
		/>
	);
};

const Header: FC<IChecklistStep> = (props) => {
	return <SATOSContentRender content={props.step.Value} />;
};
